<template>
  <div>
    <v-card
      max-width="428px"
      flat
      class="mx-auto custom-flat-card"
      elevation="0"
      color="background"
    >
      <v-card-title>
        <img
          src="@/assets/image/check.png"
          width="73"
          height="73"
          alt="checkImg"
          class="mx-auto"
        />
      </v-card-title>
      <v-card-text
        class="px-0 my-9 text-center font-Medium-24"
        style="line-height: 1.8"
      >
        {{ $t("authPage.disableGaPage.successMessage") }}
      </v-card-text>
      <v-btn
        block
        depressed
        height="50"
        type="submit"
        color="primary"
        class="auth-submit-btn mb-8"
        to="/auth/login"
        ><span class="font-Medium-14">
          {{ $t("authPage.disableGaPage.loginToExcoino") }}</span
        ></v-btn
      >
    </v-card>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped></style>
